import { useIntl } from 'react-intl'
import { useFormikContext } from 'formik'
import router, { useRouter } from 'next/router'
import {
  getProductTitle,
  getBreadCrumb,
} from '@src/routes/Configurators/products/TubesMTORedesign/ProductsConfiguration'
import {
  useProductFromQueryParam,
  useActiveStepFromQueryParam,
  SemiConfigFormValues,
} from './ProductsConfiguration'
import ConfiguratorLayout from '@src/routes/Configurators/components/ConfiguratorLayout'
import { SidebarItem } from '@src/routes/Configurators/components/LeftNavigation/LeftNavigation'
import Search from './Search'
import NextStepButtonComponent from './NextStepButtonComponent'
import { ActiveLinkType } from './enum'
import useSearch from './useSearch'
import SelectClones from './SelectClones'

const SemiConfiguratorLayout = () => {
  const product = useProductFromQueryParam()
  const productTitle = getProductTitle(product)
  const intl = useIntl()
  const { searchQuery } = useSearch()
  const formik = useFormikContext<SemiConfigFormValues>()
  const { query } = useRouter()
  const activeStep = useActiveStepFromQueryParam()
  const baseRoute = `/semi-configurators/${product.toLowerCase()}`
  const sidebarItems: SidebarItem[] = [
    {
      label: intl.formatMessage({
        id: 'CONF_PRODUCT_SEARCH',
        defaultMessage: 'Product Search',
      }),
      activeLink: activeStep === ActiveLinkType.ProductSearch,
      url: `${baseRoute}?activeLink=${ActiveLinkType.ProductSearch}`,
      linkDisable: false,
    },
    {
      label: intl.formatMessage({
        id: 'CONF_ITEM_SELECTION',
        defaultMessage: 'Select Clones',
      }),
      activeLink: activeStep === ActiveLinkType.ItemSelection,
      url: `${baseRoute}?activeLink=${ActiveLinkType.ItemSelection}`,
      linkDisable: formik.values.completedStep < 1,
    },
    {
      label: intl.formatMessage({
        id: 'SPECIFICATIONS',
        defaultMessage: 'Specifications',
      }),
      activeLink: false,
      url: `${baseRoute}?activeLink=${ActiveLinkType.Specifications}`,
      linkDisable: formik.values.completedStep < 2,
    },
    {
      label: intl.formatMessage({
        id: 'SEMI_CONF_ORF_REVIEW_CONFIRM',
        defaultMessage: 'Review & Confirm',
      }),
      activeLink: false,
      url: `${baseRoute}?activeLink=${ActiveLinkType.ReviewOrder}`,
      linkDisable: formik.values.completedStep < 3,
    },
  ]
  const breadcrumbItems = getBreadCrumb(product)
  const actionDisabled: boolean = false
  const nextStepAction: () => void = async () => {
    //action based on atcive step
    if (
      activeStep === ActiveLinkType.ProductSearch &&
      (await searchQuery({}))
    ) {
      //redirect to step 2
      formik.setFieldValue('completedStep', 1, false)
      router.push(
        {
          pathname: router.pathname,
          query: {
            country: query.country,
            language: query.language,
            activeLink: ActiveLinkType.ItemSelection,
          },
        },
        undefined,
        { shallow: true }
      )
    }
  }
  const getComponentForStep = () => {
    if (activeStep === ActiveLinkType.ProductSearch) {
      return <Search />
    } else if (activeStep === ActiveLinkType.ItemSelection) {
      return <SelectClones />
    } else {
      return <p>No Step</p>
    }
  }
  return (
    <ConfiguratorLayout
      title={productTitle}
      sidebarItems={sidebarItems}
      breadcrumbItems={breadcrumbItems}
      bodyContent={getComponentForStep()}
      tabPadding={activeStep === ActiveLinkType.ProductSearch}
      nextStepButton={
        <NextStepButtonComponent
          nextStepAction={nextStepAction}
          disabled={formik.values.loading || actionDisabled}
        />
      }
    />
  )
}

export default SemiConfiguratorLayout
